'use strict'
// Start smoothscroll-polyfill automatically.
require('./').polyfill()
